/* The recommendations row arrives after page load (the empire bundle swaps the
   section's innerHTML), so tmg-collection-swiper.js has already finished its
   one-time sweep. Re-run it for the injected row. initOne is idempotent via its
   own data-snap-ready flag, so repeat calls are free. */
(function () {
  if (window.__tmgSwiperAsyncHost) return;
  window.__tmgSwiperAsyncHost = true;

  var queued = false;

  function run() {
    queued = false;
    if (window.tmgInitCollectionSwipers) {
      window.tmgInitCollectionSwipers();
      return;
    }
    window.addEventListener(
      'load',
      function () {
        if (window.tmgInitCollectionSwipers) window.tmgInitCollectionSwipers();
      },
      { once: true }
    );
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  }

  function boot() {
    var hosts = document.querySelectorAll('[data-swiper-async-host]');
    for (var i = 0; i < hosts.length; i++) {
      new MutationObserver(function (records) {
        for (var j = 0; j < records.length; j++) {
          if (records[j].addedNodes.length) {
            queue();
            return;
          }
        }
      }).observe(hosts[i], { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
